import {NgZone} from '@angular/core';
import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {
  OperationInformation
} from '../../shared/components/operation-snackbar/operation-snackbar.component';
import {
  OperationSnackbarComponent,
  OperationStatus,
} from '../../shared/components/operation-snackbar/operation-snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  constructor(
    public snackBar: MatSnackBar,
    private readonly zone: NgZone,
  ) {
  }

  open(
    message: string,
    action = OperationStatus.SUCCESS,
    reason?: string,
    duration = 5000,
  ) {
    this.zone.run(() => {
      this.snackBar.openFromComponent(OperationSnackbarComponent, {
        data: {
          message,
          reason,
          status: action,
        } as OperationInformation,
        duration,
      });
    });
  }

  openClosable(
    message: string,
    action = OperationStatus.SUCCESS,
    reason?: string,
  ) {
    this.zone.run(() => {
      this.snackBar.openFromComponent(OperationSnackbarComponent, {
        data: {
          message,
          reason,
          status: action,
          closable: true,
        } as OperationInformation,
      });
    });
  }

  openWithUrl(
    message: string,
    url?: string,
    action = OperationStatus.SUCCESS,
    reason?: string,
    duration = 5000,
  ) {
    this.zone.run(() => {
      this.snackBar.openFromComponent(OperationSnackbarComponent, {
        data: {
          message,
          reason,
          status: action,
          url,
        } as OperationInformation,
        duration,
      });
    });
  }

  close() {
    this.snackBar.dismiss();
  }
}
